//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'OrderPanel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    orderEdit (key) {
      this.$router.push({path: '/order/order_edit', query: { order_id: key }})
    },
    orderInfo (key) {
      this.$router.push({path: '/order/order_info', query: { order_id: key }})
    },
    onImgError (item, $event) {
      this.$emit('on-img-error', JSON.parse(JSON.stringify(item)), $event)
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc
      }
    },
    getUrl (url) {
      return this.getUrl2(url, this.$router)
    },
    onClickFooter () {
      this.$emit('on-click-footer')
      this.go(this.footer.url, this.$router)
    },
    onClickHeader () {
      this.$emit('on-click-header')
    },
    onItemClick (item) {
      this.$emit('on-click-item', item)
      this.go(item.url, this.$router)
    },
    go (url, $router) {
      if (/^javas/.test(url) || !url) return
      const useRouter = typeof url === 'object' || ($router && typeof url === 'string' && !/http/.test(url))
      if (useRouter) {
        if (typeof url === 'object' && url.replace === true) {
          $router.replace(url)
        } else {
          url === 'BACK' ? $router.go(-1) : $router.push(url)
        }
      } else {
        window.location.href = url
      }
    },
    getUrl2 (url, $router) {
      // Make sure the href is right in hash mode
      if ($router && !$router._history && typeof url === 'string' && !/http/.test(url)) {
        return '#!' + url
      }
      return url && typeof url !== 'object' ? url : 'javascript:void(0);'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/widget/OrderPanel.vue